module.exports = "static/assets/a386a58fa9c00de141c32b5b11e5327e.mp3";